import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const PORTAL_TOKEN_KEY = "cl_portal_token";

// Instancia isolada do Portal do Cliente (sessao separada do admin/revendedora).
export const papi = axios.create({ baseURL: `${BASE}/api`, withCredentials: false });

papi.interceptors.request.use((config) => {
  const t = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function savePortalToken(t) {
  if (t) localStorage.setItem(PORTAL_TOKEN_KEY, t);
}
export function clearPortalToken() {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
}
export function hasPortalToken() {
  return !!localStorage.getItem(PORTAL_TOKEN_KEY);
}
